import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-striped table-hover" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_edit_button = _resolveComponent("bs5-edit-button")!
  const _component_bs5_delete_button = _resolveComponent("bs5-delete-button")!
  const _component_bs5_group_button = _resolveComponent("bs5-group-button")!
  const _component_AddClientModal = _resolveComponent("AddClientModal")!
  const _component_EditClientModal = _resolveComponent("EditClientModal")!
  const _component_GenerateLicenseModal = _resolveComponent("GenerateLicenseModal")!
  const _component_ClientLicensesModal = _resolveComponent("ClientLicensesModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.distributor.name), 1),
    _createVNode(_component_bs5_base_button, {
      variant: "success",
      class: "mb-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddClientModal = true))
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1),
        _createTextVNode(" Add Client ")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "table-dark" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "#"),
            _createElementVNode("th", null, "Name"),
            _createElementVNode("th", null, "Description"),
            _createElementVNode("th", null, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: client.id
            }, [
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(client.name), 1),
              _createElementVNode("td", null, _toDisplayString(client.description), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_bs5_group_button, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_bs5_edit_button, {
                      onClick: ($event: any) => (_ctx.editClient(client.id))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_bs5_base_button, {
                      variant: "warning",
                      onClick: ($event: any) => (_ctx.openGenerateLicenseModal(client.id))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Generate License ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_bs5_base_button, {
                      variant: "info",
                      onClick: ($event: any) => (_ctx.openViewLicensesModal(client.id))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" View Licenses ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_bs5_delete_button, {
                      onClick: ($event: any) => (_ctx.deleteClient(client.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_AddClientModal, {
      visible: _ctx.showAddClientModal,
      distributorId: _ctx.distributor.id,
      onClose: _cache[1] || (_cache[1] = () => { _ctx.showAddClientModal = false; _ctx.selectedClientId = '' }),
      onClientAdded: _ctx.fetchClients
    }, null, 8, ["visible", "distributorId", "onClientAdded"]),
    _createVNode(_component_EditClientModal, {
      visible: _ctx.showEditClientModal,
      clientId: _ctx.selectedClientId,
      onClose: _cache[2] || (_cache[2] = () => { _ctx.showEditClientModal = false; _ctx.selectedClientId = '' }),
      onClientUpdated: _ctx.fetchClients
    }, null, 8, ["visible", "clientId", "onClientUpdated"]),
    _createVNode(_component_GenerateLicenseModal, {
      visible: _ctx.showGenerateLicenseModal,
      clientId: _ctx.selectedClientId,
      onClose: _cache[3] || (_cache[3] = () => { _ctx.showGenerateLicenseModal = false; _ctx.selectedClientId = '' }),
      onLicenseGenerated: _ctx.fetchClients
    }, null, 8, ["visible", "clientId", "onLicenseGenerated"]),
    _createVNode(_component_ClientLicensesModal, {
      visible: _ctx.showViewLicensesModal,
      clientId: _ctx.selectedClientId,
      onClose: _cache[4] || (_cache[4] = () => { _ctx.showViewLicensesModal = false; _ctx.selectedClientId = '' })
    }, null, 8, ["visible", "clientId"])
  ]))
}